import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import CardContent from '@material-ui/core/CardContent';
import ReactHtmlParser from 'react-html-parser';
import VideoDetailTags from './VideoDetailTags';
import CardActions from '@material-ui/core/CardActions';
import classnames from 'classnames';
import VideoDetailUpNext from "/components/VideoDetail/VideoDetailUpNext";
import VideoDetailShareBtn from "/components/VideoDetail/VideoDetailShareBtn";

const styles = theme => ({
    root: {
      padding: 0,
      background: '#282828',
      border: '1px solid #363636',
      marginBottom: 14,
      [theme.breakpoints.down('sm')]: {
        background: 'initial',
        border: 0,
        marginBottom: -14,
      },
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    playlistTitleStyle: {
        color: '#fff',
        marginLeft: 5
    }
});

class VideoPlaylist extends React.Component {

  render() {
    const { classes, playlistToggle, playlistOpen, playlist, videoUrl, queryId, playlistPos } = this.props;
    return(
      <React.Fragment>
          <div className={classes.root}>
                <CardActions style={{display: 'block'}}>
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center" onClick={playlistToggle}>
                        <Typography component="p" className={classes.playlistTitleStyle}>
                            {playlist.title}
                        </Typography>
                        <IconButton
                        style={{color: '#fff', marginTop: 0}}
                        className={classnames(classes.expand, {
                            [classes.expandOpen]: playlistOpen,
                        })}
                        aria-expanded={playlistOpen}
                        aria-label="Show more"
                        >
                        <ExpandMoreIcon style={{fontSize: 20}} />
                        </IconButton>
                    </Grid>
                   <Typography component="div" style={{marginLeft: 10, fontSize: 12, color: '#fff', marginTop: '-10px'}}>
                      <span>{playlist.author && playlist.author.name} </span>
                      <span style={{ paddingRight: 7 }}>- {playlistPos}/{playlist.video_count}</span> 

                    </Typography>
                </CardActions>

            <Collapse in={playlistOpen} timeout="auto" unmountOnExit>
              {playlistOpen ?
                <div style={{padding: 0}}>
                     <Hidden only={['lg', 'xl']}>
                        <div style={{padding: '10px 14px 0px'}}>
                            <VideoDetailShareBtn asPath={videoUrl} title={playlist.title} customProps={{style: { width: 40, height: 40, background: 'initial', marginBottom: 14, border: '1px solid #363636' } }} />
                        </div>
                    </Hidden>
                    <VideoDetailUpNext items={playlist.videos} playlistPos={playlistPos} playlist={playlist} />
                   
                </div>
                : null}
             
            </Collapse>
      
          </div>
         </React.Fragment>
      
    )
  }
}

VideoPlaylist.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VideoPlaylist);